.carousel {
  user-select: none;
  -ms-touch-action: pan-y;
  touch-action: pan-y;

  // NOTE: 100vw show a useless horizontal scroll bar
  --overflow-margin: calc((98.7vw - var(--grid-width)) / 2);
  --slide-spacing: #{spacing(24)};

  @include media-breakpoint-up(xl) {
    --slide-spacing: #{spacing(48)};
  }
}

.embla {
  overflow: hidden;
}

.embla-container {
  display: flex;
  margin-left: calc(var(--slide-spacing) * -1);
  --_track: 100%;
}

.slide {
  flex: 0 0 var(--_track);
  display: flex;
  min-width: 0;
  // Container query support: slides provide containment context
  // Named "slide" to avoid conflicts with cards that define their own "card" container
  container-type: inline-size;
  container-name: slide;
  // Spacing via padding-left + negative margin on container (Embla recommended pattern).
  // The container's margin-left compensates the first slide's padding, and the last
  // slide has no trailing space.
  padding-left: var(--slide-spacing);
}

.fill-sizing .slide > * {
  width: 100%;
  flex: 1 1;
}

// Content sizing: the card controls its width (e.g. ImmersiveCard max-width: 480px).
// Slides shrink to the card's intrinsic max-width so the next card is always visible.
.content-sizing .slide {
  flex-basis: min(calc(480px + var(--slide-spacing)), var(--_track));
}

// Slides-per-view: reads CSS custom properties set via inline style.
// --_spv holds the resolved slide count (with mobile-first fallbacks);
// --_track uses a simple calc() that postcss-calc can safely ignore.
.embla-container.custom-track {
  --_spv: var(--spv, 1);
  --_track: calc(100% / var(--_spv));

  @include media-breakpoint-up(sm) {
    --_spv: var(--spv-sm, var(--spv, 1));
  }

  @include media-breakpoint-up(md) {
    --_spv: var(--spv-md, var(--spv-sm, var(--spv, 1)));
  }

  @include media-breakpoint-up(lg) {
    --_spv: var(--spv-lg, var(--spv-md, var(--spv-sm, var(--spv, 1))));
  }

  @include media-breakpoint-up(xl) {
    --_spv: var(
      --spv-xl,
      var(--spv-lg, var(--spv-md, var(--spv-sm, var(--spv, 1))))
    );
  }

  @include media-breakpoint-up(xxl) {
    --_spv: var(
      --spv-xxl,
      var(--spv-xl, var(--spv-lg, var(--spv-md, var(--spv-sm, var(--spv, 1)))))
    );
  }
}

// Slide spacing: reads CSS custom properties set via inline style.
// Each breakpoint falls back to the previous one (mobile-first cascade).
.embla-container.custom-spacing {
  --slide-spacing: var(--ss);

  @include media-breakpoint-up(sm) {
    --slide-spacing: var(--ss-sm, var(--ss));
  }

  @include media-breakpoint-up(md) {
    --slide-spacing: var(--ss-md, var(--ss-sm, var(--ss)));
  }

  @include media-breakpoint-up(lg) {
    --slide-spacing: var(--ss-lg, var(--ss-md, var(--ss-sm, var(--ss))));
  }

  @include media-breakpoint-up(xl) {
    --slide-spacing: var(
      --ss-xl,
      var(--ss-lg, var(--ss-md, var(--ss-sm, var(--ss))))
    );
  }

  @include media-breakpoint-up(xxl) {
    --slide-spacing: var(
      --ss-xxl,
      var(--ss-xl, var(--ss-lg, var(--ss-md, var(--ss-sm, var(--ss)))))
    );
  }
}

.carousel.with-mask {
  width: var(--slider-width, var(--grid-width));

  .mask {
    clip-path: inset(
      0 calc(var(--overflow-margin) - 180px) 0 var(--overflow-margin)
    );

    overflow: hidden;

    margin-left: calc(-1 * var(--overflow-margin));
    margin-right: calc(-1 * var(--overflow-margin));
    padding-left: var(--overflow-margin);
    padding-right: var(--overflow-margin);
    flex: 1;

    .embla {
      overflow: visible;
    }
  }

  &.hide-next-slide-group .mask .embla {
    overflow: hidden;
  }

  .left-overflow {
    clip-path: inset(
      0 calc(var(--overflow-margin) - 180px) 0
        calc(var(--overflow-margin) - 180px)
    );
  }
}

// Inline variant: dim the peeking card via mask-image on .mask
// The gradient fades only the rightmost 180px (the peek area defined by clip-path)
.carousel.carousel-inline.with-mask .mask {
  mask-image: linear-gradient(
    to right,
    black calc(100% - var(--overflow-margin) - var(--slide-spacing)),
    rgba(0, 0, 0, 0.33) calc(100% - var(--overflow-margin) + 24px)
  );
}

.carousel-inline.carousel-inline-with-controls {
  display: flex;
  align-items: center;
}

.button-prev-inline {
  margin-right: spacing(12);
}

.hidden {
  visibility: hidden;
}

.button-next-inline {
  margin-left: spacing(12);
  z-index: 10;
}

@media print {
  .carousel {
    margin-left: auto;
    margin-right: auto;

    .embla-container.custom-track {
      --_spv: 1;
      display: grid !important;
      grid-template-columns: repeat(var(--print-spv, 2), 1fr) !important;
      gap: spacing(24);
      --slide-spacing: 0;

      article {
        max-width: none;
      }
    }
  }
}
